import React from 'react'
import AboutOurNfts from './AboutOurNfts';
import AboutTheGame from './AboutTheGame';
import Header from './Header';
import Raffle from './Raffle';
import './Home.scss';

 const Home = () => {
    return (
        <div className="home-page-component">
            <Header />
            <AboutTheGame />
            <AboutOurNfts />
            <Raffle />
        </div>
    )
}

export default Home;